import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./construction-site-card-actions.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import { constructionSiteManager } from "../../_shark_jaws/managers/constructionSiteManager";
import disableActionButtonComponent from "../../components/disableActionButton/disableActionButtonComponen";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../waitBox/waitBoxComponent";
import Document from "../../_shark_models/Document";

class ConstructionSiteCardActionsComponent extends Component {
	constructor() {
		super("constructionSiteCardActionsComponent");
		this.addTemplate("", templateContent);
	}

	beforeRender () {
		this.set({
			__nextCSWorksheetSaveName: Shark.__generateGUID(),
		});
	}

	constructionSiteCardActionsModalConfirmSetCSWorksheet_clickHandler () {
		const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");

		if (currConstructionSiteWorksheet.document === null) {
			const addCSWorksheetBtn = document.querySelector("#addCSWorksheetBtn");

			if (addCSWorksheetBtn) {
				addCSWorksheetBtn.classList.add("btn-danger");
				addCSWorksheetBtn.classList.remove("btn-primary");
			}
			return;
		}

		waitBoxComponent.show();

		documentManager.save(currConstructionSiteWorksheet.document)
		.then(saveDocumentResponse => {
			const savedDocument = saveDocumentResponse.data;
			const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
			const previousDocumentGuid = currConstructionSiteCard.extraData.constructionSiteWorksheetDocumentGuid;
			const maintainExistingDocument = currConstructionSiteWorksheet.__maintainExistingDocument;
			
			let newStatus = currConstructionSiteCard.status;
			let statusMessage = "";

			if (currConstructionSiteCard.status === 1 && currConstructionSiteCard.extraData.quotationCCA !== "") {
				newStatus = 5;
				statusMessage = "\nIl Cantiere è ora pronto a partire.\n";
			}

			currConstructionSiteCard.set({
				"extraData.constructionSiteWorksheetDocumentGuid": savedDocument.guid,
				status: newStatus,
			});

			constructionSiteCardManager.save(currConstructionSiteCard)
			.then(saveConstructionSiteCardResponse => {
				if (maintainExistingDocument) {
					documentManager.setStatusByGuid(previousDocumentGuid, Document.STATUS_EXPIRED);
				}
				else {
					documentManager.delete2([{guid: previousDocumentGuid}]);
				}
				
				const currUser = Shark.get("currUser");
				const referenceAgent = Utils.safp(Shark.get("userList"), "guid", currConstructionSiteCard.userGuid);
				const lotReference = currConstructionSiteCard.__lotId > -1 ? " lotto #" + (currConstructionSiteCard.__lotId + 1) : "";
				
				//Dave: Qui c'è da rimettere in ordine le cose che faccio sempre, solo quando si aggiorna, solo quando si crea
				// Non mandiamo di nuovo la mail se cambia il documento.
				if (!this.get("__showReplaceCSWorksheetOptions")) {
					const body = `BuonGiorno ${referenceAgent.firstName},
					
						questa eMail per comunicarti che è stato caricato il Foglio Lavoro Cantiere relativo alla Scheda Cantiere <strong>${currConstructionSiteCard.__siteLocationLabel}</strong> ${lotReference} con partenza prevista il <strong>${currConstructionSiteCard.__startDateLabel}</strong> per il Cliente <strong>${currConstructionSiteCard.registry.clientName}</strong>.
						${statusMessage}
						Puoi visualizzare il Foglio Lavoro Cantiere <a href="${Shark.get("__cdnURL")}/${savedDocument.fileURL}">cliccando qui</a>.

						Buona Giornata,
						IPM HUB


						<small>Questa eMail è stata generata in automatico, per favore non rispondere.</small>
					`;

					const currMessage = Shark.getInstance(null, {
						body,
						senderEMail: currUser.email,
						senderName: currUser.__fullName,
						subject: "IPM HUB | Foglio Lavoro Cantiere inserito",
						receiverEMail: referenceAgent.email,
						receiverName: referenceAgent.__fullName,
					});
					userManager.sendMessage(currMessage);
				}

				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Caricato il Foglio Lavoro Cantiere per <strong>${currConstructionSiteCard.__siteLocationLabel}</strong>${lotReference}.`,
					clientGuid: currConstructionSiteCard.clientGuid,
					referenceGuid: currConstructionSiteCard.guid,
					referenceType: "constructionSiteCard",
					status: 3,
					type: "system"
				});

				if (this.get("__showReplaceCSWorksheetOptions")) {
					newFollowUp.body = `Sostituito il Foglio Lavoro Cantiere per <strong>${currConstructionSiteCard.__siteLocationLabel}</strong>${lotReference}.`;

					if (maintainExistingDocument) {
						newFollowUp.body += ` Il documento precedente è stato mantenuto in archivio.`;
					}
				}

				followUpManager.save(newFollowUp)
				.then(followUpSaveResponse => {
					if (newStatus === 5) {
						setTimeout(() => {
							constructionSiteCardManager.checkCommunicateStarting(currConstructionSiteCard);
						}, 500);
					}

					waitBoxComponent.hide();
					$(`#constructionSiteCardActionsModal`).modal("hide");
					Shark.render();
				});
			});
		});
	}

	init () {
		this.addComponents([disableActionButtonComponent, waitBoxComponent]);
	
		const currConstructionSiteWorksheet = Shark.getInstance("__smart__", {
			document: null,
			fileName: "",
			__maintainExistingDocument: false,
		});
	
		this.set({
			__showEditOptions: false,
			__showWaitingConstructionSiteCardActions: false,
		});

		Shark.set({
			currConstructionSiteWorksheet
		});
	}







	
	addCSWorksheetBtn_clickHandler () {
		const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
		
		if (currConstructionSiteCard.constructionSiteFolderGuid.trim() === "") {
			alert("Attenzione!\n\nSi è verificato un errore e non posso proseguire, per favore clicca su 'annulla' e segnala subito l'errore CSCAC-UPL-27");
			return;
		}

		document.querySelector("#uploadedCSWorksheet").click();
	}


	constructionSiteCardActionsConfirmStartBtn_clickHandler () {
		if (confirm("Sei sicuro di voler confermare la partenza del cantiere?\nSe prosegui non potrai annullare l'operazione!")) {
			const currConstructionSiteCard = Shark.get("currConstructionSiteCard");
			const currUser = Shark.get("currUser");
			
			const newCostructionSite = Shark.getInstance("ConstructionSite", {
				applicatorTeamId: currConstructionSiteCard.applicatorTeamId,
				clientGuid: currConstructionSiteCard.clientGuid,
				// endDate: currConstructionSiteCard.endDate,
				expectedEndDate: currConstructionSiteCard.endDate,
				extraData: {
					quotationCCA: currConstructionSiteCard.extraData.quotationCCA,
					relatedGuids: {
						clientGuid: currConstructionSiteCard.extraData.relatedGuids.clientGuid,
						quotationGuid: currConstructionSiteCard.extraData.relatedGuids.quotationGuid,
						constructionSiteCardGuid: currConstructionSiteCard.guid,
						siteInfoSheetGuid: currConstructionSiteCard.extraData.relatedGuids.siteInfoSheetGuid,
						visitGuid: currConstructionSiteCard.extraData.relatedGuids.visitGuid,
					},
				},
				registry: currConstructionSiteCard.registry,
				startDate: currConstructionSiteCard.startDate,
				status: 1,
				type: currConstructionSiteCard.type,
				userGuid: currUser.guid
			});

			constructionSiteManager.save(newCostructionSite)
			.then(constructionSiteSaveResponse => {
				if (constructionSiteSaveResponse.status === "ok") {
					//Dave: Ci vuole un FU!!

					// currConstructionSiteCard.set("status", 2);
					currConstructionSiteCard.import({
						extraData: {
							relatedGuids: {
								constructionSiteGuid: constructionSiteSaveResponse.data.guid
							},
						},
						status: 2
					});
					
					constructionSiteCardManager.save(currConstructionSiteCard)
					.then(saveResponse => {
						console.log({saveResponse, newCostructionSite, currConstructionSiteCard});
						$(`#constructionSiteCardActionsModal`).modal("hide");
						Shark.render();
					});
				}
			});
		}
	}

	show (mode) {
		const currConstructionSiteCard = Shark.get("currConstructionSiteCard");

		this.set({
			__showEditOptions: mode === "" && currConstructionSiteCard && currConstructionSiteCard.extraData.quotationCCA === "" && currConstructionSiteCard.status === 1,
			__showSendCSWorksheetActions: mode === "replaceCSWorksheet" || mode === "sendCSWorksheet",
			__showReplaceCSWorksheetOptions: mode === "replaceCSWorksheet",
			__showWaitingConstructionSiteCardActions: mode === "" && currConstructionSiteCard && currConstructionSiteCard.extraData.quotationCCA !== "" && currConstructionSiteCard.status === 1,
		});

		const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");
		currConstructionSiteWorksheet.__maintainExistingDocument = false;

		Shark.render();
		$(`#constructionSiteCardActionsModal`).modal("show");
	}

	uploadedCSWorksheet_changeHandler (event) {
		if (event.target.files.length === 0) {
			return;
		}

		waitBoxComponent.show();

		const addCSWorksheetBtn = document.querySelector("#addCSWorksheetBtn");

		if (addCSWorksheetBtn) {
			addCSWorksheetBtn.classList.remove("btn-danger");
			addCSWorksheetBtn.classList.add("btn-primary");
		}

		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			const uploadedDocument = uploadDocumentResponse.data.documents[0];
			const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");
			const currConstructionSiteCard = Shark.get("currConstructionSiteCard");

			uploadedDocument.set({
				folderGuid: currConstructionSiteCard.constructionSiteFolderGuid,
				role: "constructionSiteWorksheet"
			});

			if (currConstructionSiteWorksheet) {
				currConstructionSiteWorksheet.set({
					document: uploadedDocument,
					fileName: uploadedDocument.name
				});
			}
			waitBoxComponent.hide();
		});
	}
}

const constructionSiteCardActionsComponent = new ConstructionSiteCardActionsComponent();

Shark.registerComponent(constructionSiteCardActionsComponent);

export { constructionSiteCardActionsComponent };
